import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { LANGUAGES, TRANSLATIONS } from './translations';

const LangCtx = createContext(null);
const STORAGE_KEY = 'mbk_lang';

function get(obj, path) {
  return path.split('.').reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), obj);
}

export function LanguageProvider({ children }) {
  const [code, setCode] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && TRANSLATIONS[stored]) return stored;
    const navLang = (navigator.language || 'en').slice(0, 2);
    return TRANSLATIONS[navLang] ? navLang : 'en';
  });

  const meta = useMemo(() => LANGUAGES.find((l) => l.code === code) || LANGUAGES[0], [code]);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, code);
    document.documentElement.lang = code;
    document.documentElement.dir = meta.dir;
  }, [code, meta]);

  const t = (key, fallback = '') => {
    const v = get(TRANSLATIONS[code], key);
    if (v !== undefined) return v;
    const en = get(TRANSLATIONS.en, key);
    return en !== undefined ? en : fallback || key;
  };

  return (
    <LangCtx.Provider value={{ code, setCode, t, meta, languages: LANGUAGES }}>
      {children}
    </LangCtx.Provider>
  );
}

export function useT() {
  const ctx = useContext(LangCtx);
  if (!ctx) throw new Error('useT must be inside LanguageProvider');
  return ctx;
}
